import { axios, def, handleError } from './internal';

function AdminMlQueueStats(setData) {
    axios
        .post('/api/admin_ml_queue_stats', {})
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, data: res.data.data, error: null });
            } else {
                setData((prev) => ({ ...prev, loading: false, error: res.data.message ?? 'Failed' }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false, error: err.message ?? 'Request failed' }));
            handleError(err);
        });
}

export { AdminMlQueueStats };
